import { render, staticRenderFns } from "./VoteRecord.vue?vue&type=template&id=3231bb38"
import script from "./VoteRecord.vue?vue&type=script&lang=js"
export * from "./VoteRecord.vue?vue&type=script&lang=js"
import style0 from "./VoteRecord.vue?vue&type=style&index=0&id=3231bb38&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports